// @flow
import { ApiBase } from 'api/api'
import {
  makeDeleteRequest,
  makePatchRequest,
  makePostRequest,
} from 'api/fetchCalls'
import type {
  AssignedResponse,
  CreateUpdateAssignedResponse,
} from 'types/assigned_response'

export async function createAssignedResponse(
  data: CreateUpdateAssignedResponse
): Promise<AssignedResponse> {
  return makePostRequest(`${ApiBase}/assigned-responses`, {
    body: JSON.stringify(data),
  })
}

export async function updateAssignedResponse(
  id: string,
  data: CreateUpdateAssignedResponse
): Promise<AssignedResponse> {
  return makePatchRequest(`${ApiBase}/assigned-responses/${id}`, {
    body: JSON.stringify(data),
  })
}

export async function deleteAssignedResponse(id: string): Promise<void> {
  return makeDeleteRequest(`${ApiBase}/assigned-responses/${id}`)
}
